import React from 'react';
import PropTypes from 'prop-types';
import { InternalError } from 'components';

class ErrorBoundary extends React.Component {
  state = { error: false, text: "" };

  componentDidCatch(error, info) {
    console.error(error, info);
    this.setState({ error: true, text: `${error.message}, url: ${window.location.href}` });
  }

  render() {
    if(this.state.error) return <InternalError code={this.state.text} />;
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any.isRequired,
}
export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.jsx